import { admin, admin2 } from '@/api/instance'

export const GetShopSetting = async ({ shopId }) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/shopSetting`,
  })
}

//= > 創建店家
export const CreateShop = async ({ imageId, name, phone, address, email, industry, contractPlanId, googleMapLink, currency, timezone, language }) => {
  const res = await admin({
    method: 'post',
    url: '/shop',
    data: {
      imageId,
      name,
      phone,
      address,
      email,
      industry,
      contractPlanId,
      googleMapLink,
      currency,
      timezone,
      language,
    },
  })

  return res.data
}

//= > 取得店家
export const GetShops = async ({ start, limit, name }) => {
  const res = await admin({
    method: 'get',
    url: '/shop',
    params: {
      start,
      limit,
      name,
    },
  })

  return res.data
}

//= > 取得指定店家
export const GetShopById = async (shopId) => {
  return await admin2({
    method: 'get',
    url: `/shop/${shopId}`,
  })
}

//= > 店家開啟模組查詢
export const GetShopModules = async (shopId) => {
  const res = await admin({
    method: 'GET',
    url: `/shop/${shopId}/module`,
  })
  return res.data
}

//= > 店家方案功能權限與限制查詢
export const GetShopPlan = async (shopId) => {
  const res = await admin({
    method: 'GET',
    url: `/shop/${shopId}/shopPlan`,
  })
  return res.data
}

//= > 取得總店家數量
export const GetShopsCount = async ({ name }) => {
  const res = await admin({
    method: 'get',
    url: '/shop/count',
    params: {
      name,
    },
  })

  return res.data.count
}

//= > 刪除店家（GIMMATEK 服務人員設定，CNCY-10959）
export const DeleteShop = async ({ shopId }) => {
  return await admin2({
    method: 'DELETE',
    url: `/shop/${shopId}`,
  })
}

//= > 更新店家
export const UpdateShop = async ({
  shopId,
  imageId,
  name,
  phone,
  address,
  email,
  industry,
  contractPlanId,
  googleMapLink,
  language,
  DashboardAppointmentUnitId,
}) => {
  const res = await admin({
    method: 'put',
    url: `/shop/${shopId}`,
    data: {
      imageId,
      name,
      phone,
      address,
      email,
      industry,
      contractPlanId,
      googleMapLink,
      language,
      DashboardAppointmentUnitId,
    },
  })

  return res.data
}

//! 店家設定
export const FindLineConfig = async ({ shopId }) => {
  const res = await admin({
    method: 'get',
    url: `/${shopId}/lineConfig`,
  })

  return res.data
}

export const UpdateLineConfig = async ({
  shopId,
  lineId,
  channelId,
  channelSecret,
  channelAccessToken,
}) => {
  const res = await admin({
    method: 'put',
    url: `/${shopId}/lineConfig`,
    data: {
      lineId,
      channelId,
      channelSecret,
      channelAccessToken,
    },
  })

  return res.data
}

export const CreateLiff = async ({ shopId, name }) => {
  const res = await admin({
    method: 'post',
    url: `/${shopId}/lineLiff`,
    data: {
      name,
    },
  })

  return res.data
}

export const GetLiff = async ({ shopId }) => {
  const res = await admin({
    method: 'get',
    url: `/${shopId}/lineLiff`,
  })

  return res.data
}

export const UpdateLinePushConfig = async ({
  shopId,
  appointmentOpen,
  appointmentChangeTime,
  appointmentCancel,
  appointmentTomorrow,
  appointmentEnd,
  walletDeposit,
  walletUse,
  classTicketOpen,
  classTicketUse,
  phoneVerifyHelp,
  cancelClassTicket,
  cancelClassTicketUse,
  allianceActivityAddQualification,
  couponRecordOpen,
  couponRecordVoid,
  couponRecordExpireNotification,
  appointmentDepositRefund,
  shopCashbackExpirationNotify,
  shopCashbackAddPoint,
  shopCashbackUsePoint,
  shopCashbackCancelPoint,
  classTicketExpireNotification,
  memberLevelUp,
  memberLevelDown,
  memberLevelRemain,
  memberLevelExpire,
  shopPointAddPoint,
  shopPointCancelPoint,
  shopPointExpirationNotify,
  shopPointUsePoint,
  memberSuccessReferral,
  punchCardOpen,
  punchCardUse,
  punchCardExpireNotification,
  pointCardOpen,
  pointCardUse,
  pointCardExpireNotification,
  periodicBenefitRecordOpen,
  periodicBenefitRecordPause,
  periodicBenefitRecordTerminate,
  courseOrderConfirm,
  courseOrderCancel,
  courseOrderChange,
  courseSessionCancel,
  courseOrderRefundSuccess,
  courseOrderRefundFail,
  externalAppointmentOpen,
  externalAppointmentUpdate,
  externalAppointmentCancel,
  externalAppointmentTomorrow,
  memberLevelVoidRecalculation,
  amgVendingCheckoutRedirect,
}) => {
  const res = await admin({
    method: 'put',
    url: `/${shopId}/linePushConfig`,
    data: {
      couponRecordOpen,
      couponRecordVoid,
      couponRecordExpireNotification,
      phoneVerifyHelp,
      appointmentOpen,
      appointmentCancel,
      appointmentTomorrow,
      appointmentChangeTime,
      appointmentEnd,
      walletDeposit,
      walletUse,
      classTicketOpen,
      classTicketUse,
      cancelClassTicket,
      cancelClassTicketUse,
      allianceActivityAddQualification,
      appointmentDepositRefund,
      shopCashbackExpirationNotify,
      shopCashbackAddPoint,
      shopCashbackUsePoint,
      shopCashbackCancelPoint,
      classTicketExpireNotification,
      memberLevelUp,
      memberLevelDown,
      memberLevelRemain,
      memberLevelExpire,
      shopPointAddPoint,
      shopPointCancelPoint,
      shopPointExpirationNotify,
      shopPointUsePoint,
      memberSuccessReferral,
      punchCardOpen,
      punchCardUse,
      punchCardExpireNotification,
      pointCardOpen,
      pointCardUse,
      pointCardExpireNotification,
      periodicBenefitRecordOpen,
      periodicBenefitRecordPause,
      periodicBenefitRecordTerminate,
      courseOrderConfirm,
      courseOrderCancel,
      courseOrderChange,
      courseSessionCancel,
      courseOrderRefundSuccess,
      courseOrderRefundFail,
      externalAppointmentOpen,
      externalAppointmentUpdate,
      externalAppointmentCancel,
      externalAppointmentTomorrow,
      memberLevelVoidRecalculation,
      amgVendingCheckoutRedirect,
    },
  })

  return res.data
}

export const GetLinePushConfig = async ({ shopId }) => {
  const res = await admin({
    method: 'get',
    url: `/${shopId}/linePushConfig`,
  })

  return res.data
}

export const GetCouponRecordAdvancedSetting = async ({ shopId, eventType }) => {
  const res = await admin2({
    method: 'get',
    url: `/${shopId}/linePushConfig/couponRecordAdvancedSetting`,
    params: {
      eventType,
    },
  })
  return res
}

export const UpdateCouponRecordAdvancedSetting = async ({
  shopId,
  eventType,
  defaultCouponSetting,
  couponSettings,
}) => {
  const res = await admin2({
    method: 'put',
    url: `/${shopId}/linePushConfig/couponRecordAdvancedSetting`,
    params: {
      eventType,
    },
    data: {
      defaultCouponSetting,
      couponSettings,
    },
  })

  return res
}

/**
 * 取得票匣推播進階設定
 * @param {Object} params
 * @param {string} params.shopId - 店家 ID
 * @param {string} params.eventType - 事件類型：ticketBoxRecordOpen / ticketBoxRecordUse / ticketBoxRecordVoidedNotification / ticketBoxRecordExpireNotification
 * @returns {Promise} 票匣推播進階設定
 */
export const GetTicketBoxRecordAdvancedSetting = async ({ shopId, eventType }) => {
  const res = await admin2({
    method: 'get',
    url: `/${shopId}/linePushConfig/ticketBoxRecordAdvancedSetting`,
    params: {
      eventType,
    },
  })
  return res
}

/**
 * 更新票匣推播進階設定
 * @param {Object} params
 * @param {string} params.shopId - 店家 ID
 * @param {string} params.eventType - 事件類型：ticketBoxRecordOpen / ticketBoxRecordUse / ticketBoxRecordVoidedNotification / ticketBoxRecordExpireNotification
 * @param {Object} params.defaultTicketBoxSetting - 預設票匣通知設定
 * @param {boolean} params.defaultTicketBoxSetting.notify - 是否推播
 * @param {Array<{ticketBoxId: string, notify: boolean}>} params.ticketBoxSettings - 各票匣通知設定
 * @returns {Promise} 更新結果
 */
export const UpdateTicketBoxRecordAdvancedSetting = async ({
  shopId,
  eventType,
  defaultTicketBoxSetting,
  ticketBoxSettings,
}) => {
  const res = await admin2({
    method: 'put',
    url: `/${shopId}/linePushConfig/ticketBoxRecordAdvancedSetting`,
    params: {
      eventType,
    },
    data: {
      defaultTicketBoxSetting,
      ticketBoxSettings,
    },
  })

  return res
}

// Email Notify
export const CreateShopEmailNotify = async ({ shopId, email, config }) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/shopEmailNotify`,
    data: {
      email,
      config,
    },
  })
}

export const UpdateShopEmailNotify = async ({ shopId, config }) => {
  return await admin2({
    method: 'PUT',
    url: `/${shopId}/shopEmailNotify`,
    data: {
      config,
    },
  })
}

export const DeleteShopEmailNotify = async ({ shopId, id }) => {
  return await admin2({
    method: 'DELETE',
    url: `/${shopId}/shopEmailNotify/${id}`,
  })
}

export const GetShopEmailNotify = async ({ shopId }) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/shopEmailNotify`,
  })
}

export const FindShopEmailNotify = async ({ shopId, id }) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/shopEmailNotify/${id}`,
  })
}

export const GetIndustryCategories = async () => {
  return await admin2({
    method: 'GET',
    url: '/shop/industryCategories',
  })
}

// admin.shopMTagMetadata.singleFind
export const FindShopMTagMetadata = async ({ shopId }) => {
  return await admin2({
    method: 'get',
    url: `/${shopId}/shopMTagMetadata`,
  })
}
